import { render, staticRenderFns } from "./EmojiSelector.vue?vue&type=template&id=77f262b2&scoped=true&"
import script from "./EmojiSelector.vue?vue&type=script&lang=js&"
export * from "./EmojiSelector.vue?vue&type=script&lang=js&"
import style0 from "./EmojiSelector.vue?vue&type=style&index=0&id=77f262b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f262b2",
  null
  
)

export default component.exports